<app-header-style-two></app-header-style-two>


<div class="page-title-area page-title-style-two item-bg4"
    [ngStyle]="{'background-image': 'url(' + createImgPath(model.img2) + ')'}">
    <div class="container">
        <div class="page-title-content" style="text-align: right;">
            <ul class="text-background">
                <li><a routerLink="/news">{{"MENU.News" | translate}}</a></li>
                <li><a routerLink="/">{{"MENU.Home" | translate}}</a></li>
            </ul>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-8" [ngClass]="'MENU.CurrentTheme' | translate">

                <div class="blog-details-desc">
                    <h3 style="font-size: 35px ;    margin-bottom: 16px;">{{model.title}}</h3>
                    <h6 style="font-size: 28px ;    margin-bottom: 16px;">{{model.subTitle}}</h6>
                    <div class="article-image">
                        <img *ngIf="model.img3" [src]="createImgPath(model.img3)" alt="image">
                    </div>
                    <div class="article-content">
                        <div class="entry-meta">

                            <ul style="text-align: center;">
                                <li class="writer-info">
                                    <img *ngIf="model.writerImg" class="imgWriter"
                                        [src]="createImgPath(model?.writerImg)" alt="image">
                                    <span class="writer-name">{{model?.writerName}}</span>
                                    <a class="writer-description">{{model?.writerDescription}}</a>
                                </li>

                                <li class="col-md-12 row" style="color:#fece8c ;text-align: left; direction: ltr;">
                                    <i class='bx bx-calendar'></i>
                                    <span style="color:#fece8c ;text-align: left; direction: ltr;"> تاريخ النشر   {{model.creationDate | date}}</span>

                                </li>
                            </ul>
                        </div>
                        <div [innerHTML]="model.fullText"> </div>

                        <div *ngFor="let i of [1, 2, 3, 4, 5]">
                            <h3>{{ model['title' + i] }}</h3>
                            <div [innerHTML]="model['text' + i]"></div>
                            <a [href]="model['url' + i]" target="_blank">{{ model['url' + i] }}</a>
                            <div *ngIf="model['titleImg' + i]" style="text-align: center;">
                                <img [src]="createImgPath(model['titleImg' + i])" alt="image">
                            </div>
                        </div>

                    </div>


                </div>
            </div>
            <div class="col-lg-4 col-md-12" [ngClass]="'MENU.CurrentTheme' | translate">
                <aside class="widget-area">

                    <div class="widget widget_tag_cloud">
                        <h3 class="widget-title"> كلمات مفتاحية</h3>
                        <div class="tagcloud">
                            <a *ngFor="let tag of tagCloud" [routerLink]="['/blog-style-2']">
                                {{ tag.keyword }} <span class="tag-link-count">({{ tag.count }})</span>
                            </a>
                        </div>
                    </div>
                    <div class="widget widget_ednuv_posts_thumb">
                        <h3 class="widget-title"> اقرأ أيضاً</h3>
                        <app-content-loader *ngIf="!isLoading"></app-content-loader>
                        <ng-container *ngIf="isLoading">
                            <article class="item" *ngFor="let item of models">
                                <a [routerLink]="'/news-details/' +item.referenceId" class="thumb">
                                    <img [src]="createImgPath(item.img1)">
                                </a>
                                <div class="info" style="direction: rtl;">
                                    <time datetime="2024-06-30">{{item.creationDate | date:'MMMM d, y'}}</time>
                                    <h4 class="title usmall"><a [routerLink]="'/news-details/' +item.referenceId"
                                            class="ahoverText"> {{item.title}} </a></h4>
                                </div>
                                <div class="clear"></div>
                            </article>
                        </ng-container>
                    </div>

                </aside>
            </div>


        </div>
    </div>
</div>